module.exports = "/_next/static/images/e5-2-2x-ead197e287ed944b12ba96a6e2a8d68c.jpg.webp";